import type Transition from '@ember/routing/transition';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import SidebarBookingsAiController from 'uplisting-frontend/pods/-sidebar/bookings/ai/controller';

type Occasion =
  | ModelRegistry['booking']
  | ModelRegistry['booking-request']
  | ModelRegistry['enquiry'];

export default abstract class SidebarBookingsAiRoute extends BaseRoute {
  abstract parentRoute: string;
  abstract occasionType: 'booking' | 'booking-request' | 'enquiry';

  permission = 'ai_drafts.create';

  model() {
    return this.modelFor(this.parentRoute) as Occasion;
  }

  setupController(
    controller: SidebarBookingsAiController,
    model: Occasion,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    controller.occasion = model;
    controller.occasionType = this.occasionType;
  }
}
